import { IFilter } from '../../types/advancedFilters';
import { FinishingContainer } from '../../containers/advancedFilters/FinishingContainer';

export const finishing: IFilter = {
  component: FinishingContainer,
};
